import React from 'react'

export const PersonalKnife = (): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="139.306"
    height="17.752"
    viewBox="0 0 139.306 17.752"
  >
    <g
      id="Group_418"
      data-name="Group 418"
      transform="translate(633.974 -222.503)"
    >
      <g id="Group_418-2" data-name="Group 418">
        <path
          id="Path_888"
          data-name="Path 888"
          d="M-562.888,223.747l-17.329,1.109-17.381,1.426-17.276,1.691-.006,0A62.369,62.369,0,0,0-633.7,232.77l-.035.011,3.909,1.056,3.91.951,3.962.74,9.4,1.373,9.351,1.11,9.457.9,9.4.687,9.53.419a8.476,8.476,0,0,1,5.642-3.491l6.912-.362,10.037-.317,10.091-.053,10.038.106,10.09.369,10.038.529,10.038.739a3.3,3.3,0,0,0,2.859-1.367,34,34,0,0,0,4.107-10.443,2.256,2.256,0,0,0-.349-1.73,2.3,2.3,0,0,0-1.5-.956l-13.249-.243-13.208-.053-13.207.105-13.208.317-13.207.582"
          fill="#f7f5f1"
          stroke="#1d3041"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.48"
        />
        <line
          id="Line_582"
          data-name="Line 582"
          x1="0.627"
          y1="12.287"
          transform="translate(-562.888 223.747)"
          fill="none"
          stroke="#1d3041"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.48"
        />
        <line
          id="Line_583"
          data-name="Line 583"
          x1="0.581"
          y1="12.415"
          transform="translate(-559.137 223.535)"
          fill="none"
          stroke="#1d3041"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.48"
        />
        <path
          id="Path_889"
          data-name="Path 889"
          d="M-547.673,229.214a1.083,1.083,0,0,0-1.083-1.083,1.083,1.083,0,0,0-1.083,1.083,1.083,1.083,0,0,0,1.083,1.084,1.083,1.083,0,0,0,1.083-1.084"
          fill="#f7f5f1"
          stroke="#1d3041"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.48"
        />
      </g>
      <path
        id="Path_890"
        data-name="Path 890"
        d="M-560.934,232.833l-.792.053-.158.053-.106.053-.158.106-.106.106-.053.158-.053.158-.053.158"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_584"
        data-name="Line 584"
        y1="0.106"
        x2="1.479"
        transform="translate(-560.564 232.675)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_585"
        data-name="Line 585"
        y1="0.106"
        x2="1.479"
        transform="translate(-558.715 232.516)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_586"
        data-name="Line 586"
        y1="0.106"
        x2="1.532"
        transform="translate(-556.866 232.411)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_587"
        data-name="Line 587"
        y1="0.106"
        x2="1.479"
        transform="translate(-554.964 232.252)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_588"
        data-name="Line 588"
        y1="0.106"
        x2="1.479"
        transform="translate(-553.115 232.094)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_589"
        data-name="Line 589"
        y1="0.106"
        x2="1.532"
        transform="translate(-551.266 231.935)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_590"
        data-name="Line 590"
        y1="0.158"
        x2="1.479"
        transform="translate(-549.364 231.777)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_591"
        data-name="Line 591"
        y1="0.106"
        x2="1.479"
        transform="translate(-547.515 231.671)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_592"
        data-name="Line 592"
        y1="0.106"
        x2="1.532"
        transform="translate(-545.666 231.513)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_593"
        data-name="Line 593"
        y1="0.106"
        x2="1.479"
        transform="translate(-543.764 231.354)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_594"
        data-name="Line 594"
        y1="0.158"
        x2="1.479"
        transform="translate(-541.915 231.196)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_595"
        data-name="Line 595"
        y1="0.106"
        x2="1.532"
        transform="translate(-540.066 231.09)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_596"
        data-name="Line 596"
        y1="0.106"
        x2="1.479"
        transform="translate(-538.164 230.931)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_597"
        data-name="Line 597"
        y1="0.106"
        x2="1.479"
        transform="translate(-536.315 230.773)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_598"
        data-name="Line 598"
        y1="0.106"
        x2="1.532"
        transform="translate(-534.466 230.615)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_599"
        data-name="Line 599"
        y1="0.158"
        x2="1.479"
        transform="translate(-532.564 230.456)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_600"
        data-name="Line 600"
        y1="0.106"
        x2="1.479"
        transform="translate(-530.715 230.35)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_601"
        data-name="Line 601"
        y1="0.106"
        x2="1.532"
        transform="translate(-528.866 230.192)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_602"
        data-name="Line 602"
        y1="0.106"
        x2="1.479"
        transform="translate(-526.964 230.033)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_891"
        data-name="Path 891"
        d="M-525.115,230.033l.74-.106.37-.211.264-.317.158-.264"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_892"
        data-name="Path 892"
        d="M-523.424,228.765v-.106l.053-.423v-.423l-.106-.37-.053-.158"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_893"
        data-name="Path 893"
        d="M-523.688,226.969l-.159-.264-.317-.264-.37-.211h-.74"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_603"
        data-name="Line 603"
        x1="1.532"
        y2="0.053"
        transform="translate(-527.175 226.23)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_604"
        data-name="Line 604"
        x1="1.479"
        transform="translate(-529.024 226.282)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_605"
        data-name="Line 605"
        x1="1.532"
        transform="translate(-530.926 226.335)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_606"
        data-name="Line 606"
        x1="1.479"
        y2="0.053"
        transform="translate(-532.775 226.335)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_607"
        data-name="Line 607"
        x1="1.479"
        transform="translate(-534.624 226.388)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_608"
        data-name="Line 608"
        x1="1.479"
        y2="0.053"
        transform="translate(-536.526 226.388)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_609"
        data-name="Line 609"
        x1="1.479"
        y2="0.053"
        transform="translate(-538.375 226.441)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_610"
        data-name="Line 610"
        x1="1.532"
        transform="translate(-540.277 226.494)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_611"
        data-name="Line 611"
        x1="1.479"
        y2="0.053"
        transform="translate(-542.126 226.494)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_612"
        data-name="Line 612"
        x1="1.532"
        y2="0.053"
        transform="translate(-544.028 226.547)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_613"
        data-name="Line 613"
        x1="1.479"
        transform="translate(-545.877 226.599)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_614"
        data-name="Line 614"
        x1="1.479"
        y2="0.053"
        transform="translate(-547.726 226.599)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_615"
        data-name="Line 615"
        x1="1.479"
        y2="0.053"
        transform="translate(-549.628 226.652)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_616"
        data-name="Line 616"
        x1="1.479"
        transform="translate(-551.477 226.705)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_617"
        data-name="Line 617"
        x1="1.532"
        y2="0.053"
        transform="translate(-553.379 226.705)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_618"
        data-name="Line 618"
        x1="1.479"
        y2="0.053"
        transform="translate(-555.228 226.758)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_619"
        data-name="Line 619"
        x1="1.532"
        transform="translate(-557.13 226.811)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_620"
        data-name="Line 620"
        x1="1.479"
        y2="0.053"
        transform="translate(-558.979 226.811)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_621"
        data-name="Line 621"
        x1="1.479"
        y2="0.053"
        transform="translate(-560.828 226.864)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_894"
        data-name="Path 894"
        d="M-561.251,226.916h-.74l-.158-.053-.159-.053-.106-.106-.159-.106-.053-.106-.106-.158-.053-.158"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_895"
        data-name="Path 895"
        d="M-571.764,237.165l-.817-7.089a8,8,0,0,0-7.9-5.21"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_622"
        data-name="Line 622"
        x1="41.208"
        y2="2.008"
        transform="translate(-562.571 227.92)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
    </g>
  </svg>
)
